import { createTheme } from "@mui/material"

const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#d67878",
      light: "#eeb1b1",
    },
    secondary: {
      main: "#338a7e",
    },
    textcolor: {
      main: '#2b3439',
      light: '#525e6b',
      dark: '#212121',
      contrastText: '#000000',
    },
    back: {
      main: "#f8f9fa",
      light: "#f7f7f78a"
    }
  },
  typography: {
    fontSize: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'classic' },
              style: {
                backgroundColor: "white",
                borderRadius: "20px",
                color: "black",
                margin: "5px 10px",
                minWidth: "45px",
                "&:hover": {
                  backgroundColor: "whitesmoke",
                }
              },
            },
          ],
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          whiteSpace: 'normal'
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          whiteSpace: 'normal'
        }
      },
    },
  }
})

export default muiTheme

// declare new button variant
declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    classic: true;
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    textcolor: Palette['primary'];
    back: Palette['primary'];
  }

  interface PaletteOptions {
    textcolor?: PaletteOptions['primary'];
    back?: PaletteOptions['primary'];
  }
}